//BASE URL
export const BASE_URL = 'https://aboodbus.co.tz/passenger/';
export const API_URL = 'https://aboodbus.co.tz/api/';
/*
 * Passenger identity now lives on the v2 contract, at TICKETS_API_URL —
 * /api/v2/auth/* and /api/v2/account/*. See src/services/identity.js.
 *
 * USER_URL is gone. It pointed at https://197-250-2-138.sslip.io/api/v1/passenger/,
 * a bare-IP dev box, hardcoded while everything around it was env-driven — so
 * the whole passenger account system hung off a host with no DNS name. The
 * booking journey had already moved to v2; identity had not, which left the
 * site holding two base URLs and two response shapes for one user's session.
 */

/*
 * There is no ACCOUNT_API_URL any more, and that is the point.
 *
 * It existed to hold the two endpoints that had no equivalent on this host —
 * account/tickets and tickets/amendments/initialize — which kept the retired
 * arc box (197-250-2-138.sslip.io) alive in the bundle after everything else
 * had moved. Both are now served from /api/v2, so the last reference to that
 * host is gone from this site entirely.
 */

// v2 tickets backend (abood-tickets / -l12). The booking flow on this
// site is being migrated off the legacy aboodbus.co.tz/passenger/* surface
// onto the consolidated v2 contract documented in
// `abood-tickets/openapi/v2-booking.yaml`.
//
// Override at build time:
//   VUE_APP_TICKETS_API_URL=http://192.168.0.76:8001/api/v2 npm run build
// Default targets a localhost dev server — fine for `npm run serve`
// when Laravel runs on the same host.
export const TICKETS_API_URL =
  (process.env.VUE_APP_TICKETS_API_URL || 'http://127.0.0.1:8001/api/v2').replace(/\/+$/, '');

// ── WhatsApp ticket delivery settings ────────────────────────────────
// Controls the three ways a passenger can receive their ticket on
// WhatsApp. Each is an independent toggle so they can be mixed:
//   - backendNotify:     send `notify_whatsapp` in the issue payload so
//                        the server delivers it (needs backend support).
//   - shareButton:       show a "Send on WhatsApp" button on the
//                        confirmation screen (client-side, most reliable).
//   - autoOpenAfterPay:  auto-open WhatsApp right after a successful
//                        booking (can be blocked by popup blockers).
// `enabled` is the master switch. Override per-toggle at build time via
// VUE_APP_WA_* env vars ("false" disables).
const waFlag = (key, fallback) => {
  const v = process.env[key];
  if (v === undefined) return fallback;
  return String(v).toLowerCase() !== 'false';
};
export const WHATSAPP_TICKET = {
  enabled:          waFlag('VUE_APP_WA_ENABLED', true),
  backendNotify:    waFlag('VUE_APP_WA_BACKEND', true),
  shareButton:      waFlag('VUE_APP_WA_SHARE_BUTTON', true),
  autoOpenAfterPay: waFlag('VUE_APP_WA_AUTO_OPEN', false),
};